__turbopack_context__.v({
  "content": "Traffic-module-scss-module__8NMPDG__content",
  "timestamp": "Traffic-module-scss-module__8NMPDG__timestamp",
  "title": "Traffic-module-scss-module__8NMPDG__title",
});
